import styled from 'styled-components'

export const Identity = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;

  strong {
    color: #252a32;
    font-size: 13px;
  }

  span {
    color: #89919d;
    font-size: 11px;
  }
`

export const Amount = styled.strong`
  color: #252a32;
  font-size: 13px;
`
